import React from "react";
import { Box, CircularProgress } from "@mui/material";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormServiceSettings from "../../components/service-settings/FormServiceSettings";
import { useGetServiceSettings } from "../../hooks/service-settings/useGetServiceSettings";
import { useUpdateServiceSettings } from "../../hooks/service-settings/useUpdateServiceSettings";

const ServiceSettingsPage = () => {
    const { isLoading, error, settingsData } = useGetServiceSettings();
    const { updateServiceSettingsMutate, isPending } = useUpdateServiceSettings();

    if (isLoading) {
        return (
            <WrapperSection>
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
                    <CircularProgress />
                </Box>
            </WrapperSection>
        );
    }

    if (error) return null;

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormServiceSettings
                currentData={settingsData}
                onSubmit={updateServiceSettingsMutate}
                isLoading={isPending}
            />
        </WrapperSection>
    );
};

export default ServiceSettingsPage;
